/** A file whose rows a run replaces, because the run has a file with its name. */
export interface ReplacedFile {
  fileName: string
  receivedAt: string
}

/** A run refused until a person confirms it replaces the rows of other files of the config. */
export interface ReplacementRequest {
  configName: string
  files: ReplacedFile[]
}

/** The replacement a 409 `FILE_NAME_EXISTS` answer asks to confirm; null for any other error. */
export function replacementRequestOf(error: unknown): ReplacementRequest | null {
  if (!error || typeof error !== 'object') return null
  const { status, data } = error as { status?: unknown; data?: unknown }
  if (status !== 409 || !data || typeof data !== 'object') return null
  const body = data as { code?: unknown; configName?: unknown; files?: unknown }
  if (body.code !== 'FILE_NAME_EXISTS' || !Array.isArray(body.files)) return null
  const files = body.files.flatMap((file: unknown) => {
    const { name, receivedAt } = (file ?? {}) as { name?: unknown; receivedAt?: unknown }
    return typeof name === 'string' && typeof receivedAt === 'string'
      ? [{ fileName: name, receivedAt }]
      : []
  })
  return { configName: typeof body.configName === 'string' ? body.configName : '', files }
}
